<template>
  <div
    class="grid grid-cols-2 gap-x-4 gap-y-7"
    :class="{
      'sm:grid-cols-3': gridClass.sm,
      'md:grid-cols-4': gridClass.md,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { GridClass } from "~/@types/feed"

withDefaults(
  defineProps<{
    gridClass?: GridClass
  }>(),
  {
    gridClass: () => ({
      sm: true,
      md: true,
    }),
  },
)
</script>
